import { useSyncExternalStore } from 'react';

// El mismo corte que `lg` (UI-SPEC §Layout frame): por debajo se ve la composición móvil. Las piezas
// con dos árboles lo usan para saber si el suyo es el visible; el oculto no corre reloj ni observa nada.
const CONSULTA_ESCRITORIO = '(min-width: 1024px)';

function consulta(): MediaQueryList | null {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
    return window.matchMedia(CONSULTA_ESCRITORIO);
}

// Llamada opcional: algunos navegadores antiguos (y algún doble de test) no traen addEventListener.
function suscribir(aviso: () => void): () => void {
    const lista = consulta();
    lista?.addEventListener?.('change', aviso);
    return () => lista?.removeEventListener?.('change', aviso);
}

function leer(): boolean {
    return consulta()?.matches ?? false;
}

// En el servidor no hay ancho: ningún árbol se da por visible, así que ninguno arranca antes de hidratar.
function enServidor(): boolean {
    return false;
}

export function useEsEscritorio(): boolean {
    return useSyncExternalStore(suscribir, leer, enServidor);
}
